import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddNewCustomerForm } from '../../../../components/AddCustomer/AddNewCustomerForm'

export const CustomerPopUp = () => {
  const { menuTarget, onSuccessSubmit } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.customer} target={menuTarget?.target}>
      <AddNewCustomerForm onSuccessSubmit={onSuccessSubmit} />
    </PopUpContainer>
  )
}
